
      import { api } from './src/api.js';
      document.getElementById('sim-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(e.target);
        const monthly_kwh = (fd.get('monthly_kwh') || '').split(',').map((s) => parseFloat(s.trim())).filter((n) => Number.isFinite(n));
        const data = {
          region: fd.get('region'),
          pv_kw: parseFloat(fd.get('pv_kw')),
          monthly_kwh,
          battery_kwh: parseFloat(fd.get('battery_kwh')) || undefined,
        };
        const result = document.getElementById('result');
        result.textContent = '計算中...';
        try {
          const out = await api.simulateHome(data);
          result.textContent = JSON.stringify(out, null, 2);
        } catch (err) {
          result.textContent = 'ERROR: ' + err.message;
        }
      });
    